"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTrusted = void 0;
const types_1 = require("../../../security/authoriser/types");
const repository_1 = require("../../../security/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const repository_2 = require("../../../security/authoriser/infra/repositories/repository");
const events_1 = require("../../../security/events");
const baseTrusted_1 = require("./baseTrusted");
class MbTrusted extends baseTrusted_1.BaseTrusted {
    constructor() {
        super(...arguments);
        this.doRetry = async () => {
            try {
                const { data } = await (0, repository_2.regeneratePUSH)(this.api, this.progressId);
                this.data = { ...this.data, biometricId: data.biometricId };
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION, success: true });
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION, success: false });
            }
        };
    }
    async doVerify() {
        this.closeAsyncConnection();
        const checkVerificationData = { biometricId: this.data.biometricId };
        const isVerified = await repository_1.trustedVerificationStatusRepository.isVerified(this.api, this.progressId, checkVerificationData);
        if (!isVerified) {
            throw new Error('Validation from the trusted device is required');
        }
        return {
            type: types_1.ChallengeType.NONE,
            progressId: this.progressId,
        };
    }
}
exports.MbTrusted = MbTrusted;
//# sourceMappingURL=trusted.js.map